import {makeActionCreator} from '../utility'

export const FETCH_ALL_APPLICATIONS = 'FETCH_ALL_APPLICATIONS'
export const fetchAllApplications = makeActionCreator(FETCH_ALL_APPLICATIONS, 'data')

export const USER_APPLICATIONS_RECEIVED = 'USER_APPLICATIONS_RECEIVED'
export const userApplicationsReceived = makeActionCreator(USER_APPLICATIONS_RECEIVED, 'data')